import React, { useState } from 'react';
import Header from './Header.js';

import configData from './Config';
import { Helmet } from 'react-helmet';

import homepage_section1 from './Assets/homepage_section1.jpg';
import homepage_section2 from './Assets/homepage_section2.jpg';
import homepage_section3 from './Assets/homepage_section3.jpg';
import homepage_facebookicon from './Assets/homepage_facebookicon.png';
import homepage_linkedinicon from './Assets/homepage_linkedinicon.png';
import homepage_instagramicon from './Assets/homepage_instagramicon.png';

import './HomePage.css';

function Homepage({ state, setState }) {
    const [planoption, setPlanoption] = useState(1);
    const [paymentoption, setPaymentoption] = useState(1);

    const handleClose = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
    }

    const handlePlan = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Plan state={state} setState={setState} />, modaltype: 'small', modaltitle: 'Plan' }))
    }

    const handleDemo = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Demo state={state} setState={setState} />, modaltype: 'small', modaltitle: 'Demo' }))
    }

    function Plan() {
        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>We are only accepting Cash Payments at the moment.</div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <a
                                href={`https://wa.me/96170617919?text=Hello%2C%20I%20would%20like%20to%20subscribe%20to%20the%20.%20Please%20provide%20payment%20details.`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Contact via WhatsApp
                            </a>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className='modal_button' onClick={handleClose}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function Demo() {
        const startDemo = () => {
            setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
            setState(state => ({
                ...state,
                user: {
                    userid: '682dca6f71591',
                    usertoken: '73483a1673e5540fb410746baf18a5c4',
                    useremail: 'demouser@demo.com',
                    username: 'demouser',
                    usertype: 0,
                }
            }))
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>Project XYZ 1344 Demo. Press Start Demo to start.</div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className='modal_button' onClick={startDemo}>Start Demo</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='homepage'>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta name="description" content="Our software provides powerful cloud-based accounting solutions to help businesses manage finances, track expenses, and generate insightful financial reports." />
                <meta name="keywords" content="accounting software, financial management, cloud accounting, bookkeeping, expense tracking" />
                <meta name="author" content="Accounting Dynamics" />
                <meta property="og:title" content="Cloud-Based Accounting Software" />
                <meta property="og:description" content="Our software provides powerful cloud-based accounting solutions for businesses of all sizes." />
                <meta property="og:image" content={homepage_section1} />
                <meta property="og:url" content={window.location.href} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Cloud-Based Accounting Software" />
                <meta name="twitter:description" content="Our software provides powerful cloud-based accounting solutions for businesses of all sizes." />
                <meta name="twitter:image" content={homepage_section1} />
                <title>Cloud-Based Accounting Software</title>
            </Helmet>

            <Header state={state} setState={setState} />

            <div className='homepage_section'>
                <div className='homepage_sectionleft'>
                    <h1 className='homepage_title'>Cloud-based Accounting Software</h1>
                    <p className='homepage_description'>
                        Our software provides powerful cloud-based accounting solutions to help businesses manage finances efficiently.
                        With our platform, you can track expenses, automate bookkeeping, and generate insightful financial reports.
                    </p>
                </div>
                <div className='homepage_sectionright'>
                    <div className='homepage_paymentplans'>
                        <div className="homepage_paymentplan">
                            <h3>Plan</h3>
                            <select className='homepage_paymentplanselect' value={planoption} onChange={(e) => setPlanoption(e.target.value)}>
                                <option value={1}>Basic Plan</option>
                                <option value={2}>Pro Plan</option>
                            </select>
                            <h3>Option</h3>
                            <select className='homepage_paymentplanselect' value={paymentoption} onChange={(e) => setPaymentoption(e.target.value)}>
                                <option value={1}>Monthly</option>
                                <option value={12}>Yearly</option>
                            </select>
                            {planoption == 1 && paymentoption == 1 && <p className="homepage_paymentplanprice">$4/Month</p>}
                            {planoption == 1 && paymentoption == 12 && <p className="homepage_paymentplanprice">$50/Year</p>}
                            {planoption == 2 && paymentoption == 1 && <p className="homepage_paymentplanprice">$10/Month</p>}
                            {planoption == 2 && paymentoption == 12 && <p className="homepage_paymentplanprice">$110/Year</p>}
                            {planoption == 1 &&
                                <ul className='homepage_paymentplanfeatures'>
                                    <li>Limited to 1 Project</li>
                                    <li>Only 1 User Access</li>
                                    <li>Basic Accounting Features</li>
                                </ul>
                            }
                            {planoption == 2 &&
                                <ul className='homepage_paymentplanfeatures'>
                                    <li>Multiple Projects</li>
                                    <li>Multi-user Access</li>
                                    <li>Advanced Accounting Features</li>
                                    <li>Payroll</li>
                                </ul>
                            }
                            <button className='homepage_planbutton' onClick={handlePlan}>Start Plan</button>
                            <button className='homepage_demobutton' onClick={handleDemo}>Demo Project XYZ</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className='homepage_section'>
                <div className='homepage_sectionleft'>
                    <h1 className='homepage_title'>Optimize Your Finances with Smart Accounting</h1>
                    <p className='homepage_description'>
                        Take full control of your financial operations with streamlined automation, making bookkeeping easier and more efficient. Our software automates the import of financial data from various sources, allowing for quick and accurate record-keeping. You can easily handle bulk operations like invoicing, expense tracking, and reconciliations, saving time and reducing the risk of errors. With automated workflows, managing financial tasks becomes seamless, ensuring that your business runs smoothly without the hassle of manual processes.
                    </p>
                </div>
                <div className='homepage_sectionright'>
                    <img className='homepage_image' src={homepage_section1} alt="Accounting Software" />
                </div>
            </div>

            <div className='homepage_section'>
                <div className='homepage_sectionleft'>
                    <img className='homepage_image' src={homepage_section2} alt="Financial Automation" />
                </div>
                <div className='homepage_sectionright'>
                    <h1 className='homepage_title'>Accounting System</h1>
                    <p className='homepage_description'>Our accounting system helps manage all your financial operations in one place. You can easily track bookkeeping transactions, manage cash accounts, and generate accurate financial statements. It records transactions related to clients, suppliers, inventory, payroll, invoices, and collections. Whether you're handling accounts payable or receivable, our system ensures accuracy and compliance, making financial management smoother and more efficient.</p>
                    <h1 className='homepage_title'>Automatic Backups</h1>
                    <p className='homepage_description'>Our system ensures that your data is always protected with automatic backups. Regular, scheduled backups run without interruption, safeguarding your financial records, transactions, and other critical data. Whether it's daily, weekly, or monthly, our platform ensures that your data is securely stored and easily recoverable in case of unexpected events, giving you peace of mind and preventing data loss.</p>
                </div>
            </div>

            <div className='homepage_section'>
                <div className='homepage_sectionleft'>
                    <h1 className='homepage_title'>Industries We Serve</h1>
                    <ul>
                        <li><strong>Small Businesses</strong>: Simplify accounting and focus on growth.</li>
                        <li><strong>Freelancers</strong>: Effortlessly manage invoices, expenses, and tax deductions.</li>
                        <li><strong>Startups</strong>: Streamline financial management as you scale your business.</li>
                        <li><strong>Consultants</strong>: Keep track of projects, bill clients, and manage expenses with ease.</li>
                        <li><strong>Contractors</strong>: Easily handle project-based accounting, invoicing, and job costing.</li>
                        <li><strong>Retailers</strong>: Manage sales, inventory, and financial transactions all in one place.</li>
                        <li><strong>E-commerce</strong>: Simplify online sales tracking, taxes, and payments for your store.</li>
                        <li><strong>Manufacturing</strong>: Track costs, production expenses, and manage large-scale operations.</li>
                        <li><strong>Restaurants</strong>: Manage sales, inventory, payroll, and food costs for smooth operations.</li>
                    </ul>
                </div>
                <div className='homepage_sectionright'>
                    <img className='homepage_image' src={homepage_section3} alt="Industries We Serve" />
                </div>
            </div>

            <div className='homepage_footer'>
                <div className='homepage_footercolumn'>
                    <div className='homepage_footertitle'>Contact Us</div>
                    <div className='homepage_footercontact'>Email: dservicesme@gmail.com</div>
                </div>
                <div className='homepage_footercolumn'>
                    <div className='homepage_socialicon' title="Facebook">
                        <a href={configData.FACEBOOKLINK} target="_blank" rel="noopener noreferrer">
                            <img className='homepage_facebookicon' src={homepage_facebookicon} alt="Facebook Icon" />
                        </a>
                    </div>
                    <div className='homepage_socialicon' title="LinkedIn">
                        <a href={configData.LINKEDINLINK} target="_blank" rel="noopener noreferrer">
                            <img className='homepage_linkedinicon' src={homepage_linkedinicon} alt="LinkedIn Icon" />
                        </a>
                    </div>
                    <div className='homepage_socialicon' title="Instagram">
                        <a href={configData.INSTAGRAMLINK} target="_blank" rel="noopener noreferrer">
                            <img className='homepage_instagramicon' src={homepage_instagramicon} alt="Instagram Icon" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Homepage;